/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoManagerTwoFactorLogListRequest model module.
 * @module model/ManagerControllerDtoManagerTwoFactorLogListRequest
 * @version 1.0
 */
class ManagerControllerDtoManagerTwoFactorLogListRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerTwoFactorLogListRequest</code>.
     * @alias module:model/ManagerControllerDtoManagerTwoFactorLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        ManagerControllerDtoManagerTwoFactorLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerTwoFactorLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerTwoFactorLogListRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerTwoFactorLogListRequest} The populated <code>ManagerControllerDtoManagerTwoFactorLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerTwoFactorLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('searchCode')) {
                obj['searchCode'] = ApiClient.convertToType(data['searchCode'], 'String');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerTwoFactorLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerTwoFactorLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoManagerTwoFactorLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['searchCode'] && !(typeof data['searchCode'] === 'string' || data['searchCode'] instanceof String)) {
            throw new Error("Expected the field `searchCode` to be a primitive type in the JSON string but got " + data['searchCode']);
        }
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}

ManagerControllerDtoManagerTwoFactorLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} searchCode
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['searchCode'] = undefined;

/**
 * @member {String} searchString
 */
ManagerControllerDtoManagerTwoFactorLogListRequest.prototype['searchString'] = undefined;






export default ManagerControllerDtoManagerTwoFactorLogListRequest;

